export let AccountingStatusFilter = /*#__PURE__*/function (AccountingStatusFilter) {
  AccountingStatusFilter["All"] = "";
  AccountingStatusFilter["Synced"] = "synced";
  AccountingStatusFilter["NotSynced"] = "notSynced";
  return AccountingStatusFilter;
}({});